import { render } from "./company-lists-item-placeholder.vue?vue&type=template&id=5820087d&scoped=true&ts=true"
import script from "./company-lists-item-placeholder.vue?vue&type=script&lang=ts"
export * from "./company-lists-item-placeholder.vue?vue&type=script&lang=ts"

import "./company-lists-item-placeholder.vue?vue&type=style&index=0&id=5820087d&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5820087d"]])

export default __exports__